import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { isIOS, isMacOS } from '../../utils/platform';
import { GoatRadioAppLinks } from '../../utils/const';
import { postMessageToParent } from '../../utils/window';
import { TypeOfButtonClicked } from '../../utils/types';

const DownloadAppButton: FC = () => {
  const handleDownloadClick = () => {
    try {
      postMessageToParent(TypeOfButtonClicked.download);
    } catch (error) {
      console.error('Error tracking download app event:', error);
    }
  };

  const linkText = 'Jetzt auch als App!';

  const isAppleDevice = isIOS() || isMacOS;
  const appLink = isAppleDevice
    ? GoatRadioAppLinks.ios
    : GoatRadioAppLinks.android;

  return (
    <DownloadAppButtonWrapper>
      <DownloadAppButtonLink
        href={appLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleDownloadClick}
      >
        {linkText}
      </DownloadAppButtonLink>
    </DownloadAppButtonWrapper>
  );
};

export default DownloadAppButton;

const DownloadAppButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  [theme.breakpoints.up('gw')]: {
    justifyContent: 'flex-start',
    marginBottom: 18,
    paddingLeft: 12,
  },
}));

const DownloadAppButtonLink = styled('a')(() => ({
  display: 'flex',
  padding: '10px 24px',
  borderRadius: 4,
  backgroundColor: '#00E3C6',
  color: '#1A1A1A',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '20px',
  textAlign: 'center',
  textDecoration: 'none',
}));
